<template>
<div tabindex="0" class="e-card" id="stage">
  <div v-if="!eventload">... Loading</div>
  <div v-else class="e-card-title" style="display: inline-block">
  Update {{ jobEvent.jobCategroy }} Event</div>
    <div>
      <div class="e-card-content" v-if="jobEvent">
        <div class="form-row">
          <p style="color: black; font-size: 14px; ">
                  <b>Group:</b> {{ jobEvent.jobGroup }}
                </p>
        </div>
        <div class="form-row">
          <p style="color: black; font-size: 14px; ">
                  <b>Email Template:</b> {{ jobEvent.emailStage }}
                </p>
        </div>
        <div class="form-row" v-if="jobEvent">
          <p style="color: black; font-size: 14px; ">
                  <b>Title:</b> {{ jobEvent.jobTitle }}
                </p>
        </div>
        <div class="form-row">
               <div style="width:150px;" class="form-row-input" v-if="jobEvent.jobCategroy!=='Job'">
                       <label>InActive/Active:</label>
               </div>
               <div style="width:150px;" class="form-row-input" v-if="jobEvent.jobCategroy!=='Job'">
                        <ejs-switch id="status" v-model="jobEvent.isActive"
                                    ref="refStatus"
                                    :checked="jobEvent.isActive"></ejs-switch>
                </div>
        </div>
        <div class="form-row">
            <div style="width:80%;" class="form-row-input">
              <scc-input-validator :rules="[requiredRule]"
                :value="jobEvent.description"
                @validate="v => this.isTemplateValid=v">
                <ejs-textbox ref="refTemplate"
                height="340"
                width="100%"
                float-label-type="Always"
                placeholder="Description *"
                v-model="jobEvent.description"
                >
                </ejs-textbox>
              </scc-input-validator>
            </div>
        </div>
        <div class="form-row">
           <div style="width:80%;" class="form-row-input"  v-if="jobEvent.jobCategroy!=='Job'">
            <ejs-numerictextbox
              float-label-type="Always"
              placeholder="Wait Period *"
              format = "n0"
              :showSpinButton="spin"
              v-model="jobEvent.waitPeriod" />
          </div>
        </div>
         <div class="form-row">
           <div style="width:80%;" class="form-row-input">
            <ejs-datepicker
            v-model="jobEvent.startDate"
            placeholder="Start *"
            :min="minVal"
            :max="maxVal"
            float-label-type="Always"
            :format="dateFormat"></ejs-datepicker>
          </div>
        </div>
        <div class="form-row">
           <div style="width:80%;" class="form-row-input">
            <ejs-datepicker
            v-model="jobEvent.endDate"
            placeholder="End"
            :min="minVal"
            :max="maxVal"
            float-label-type="Always"
            :format="dateFormat"></ejs-datepicker>
          </div>
        </div>
        <div class="form-row" v-if="jobEvent.jobGroup=='OperatingPermit'">
          <div style="width:80%;" class="form-row-input">
            <ejs-dropdownlist
            float-label-type="Always"
            :dataSource='operationalPrices'
            :fields='registrationFields'
            placeholder='Registration *'
            v-model='jobEvent.tmsRegistrationId' >
            </ejs-dropdownlist>
          </div>
        </div>
        <div style="width:100%;">
            <ejs-button type="button" v-on:click.native="onSubmitButtonClick"
                        cssClass="e-info margin-button">Submit</ejs-button>
            <ejs-button v-on:click.native="onCancelButtonClick"
                        cssClass="e-danger margin-button">Cancel</ejs-button>
        </div>
    </div>
    <div  style="width: 80%;margin-left: 20px;" v-if="jobEvent.jobCategroy == 'Job'">
      <div class="form-row">
        <h3>eService Job History List</h3>
      </div>
      <ejs-grid
        :dataSource="jobEventLogs"
        ref="refjobEventLog"
        :allowSorting="true"
        :allowPaging="true"
        :pageSettings="pageSettings"
        :toolbar="toolbarOptions"
        enablePersistence="true"
        :allowTextWrap="true"
        :textWrapSettings="wrapSettings"
      >
        <e-columns>
          <e-column field="jobYear" width="13%" headerText="Event Year" textAlign="Left" />
          <e-column field="jobTitle" width="17%" headerText="Job Title" textAlign="Left" />
          <e-column field="createDate" width="26%" headerText="Start Date"  type="date"
            format="MMM dd, yyyy"
            textAlign="Left" />
          <e-column field="endDate" width="10%" headerText="End Date"  type="date"
            format="MMM dd, yyyy"
            textAlign="Left" />
          <e-column field="emailStage" width="18%" headerText="Email Stage" textAlign="Left" />
        </e-columns>
      </ejs-grid>
      <br>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { TextBoxPlugin, NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { RadioButtonPlugin, SwitchPlugin } from '@syncfusion/ej2-vue-buttons';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import SccInputValidator from '@/components/base/scc-input-validator.vue';
import {
  getOperationalPrices,
} from '../../product-prices/services/product-price-api';
import { FETCH_JOB_EVENT_LOGS } from '../../product-prices/store';
import { FETCH_JOB_EVENT, POST_JOB_EVENT } from '../store';

Vue.use(TextBoxPlugin);
Vue.use(DatePickerPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(RadioButtonPlugin);
Vue.use(SwitchPlugin);

export default {
  name: 'JobEventEdit',
  provide: {
  },
  components: {
    SccInputValidator,

  },
  data() {
    return {
      id: null,
      isSubjectLineValid: false,
      isTemplateValid: false,
      requiredRule: {
        regEx: '^(?!\\s*$).+',
        message: 'This field is required',
      },
      spin: false,
      dateFormat: 'yyyy-MM-dd',
      operationalPrices: null,
      registrationFields: { text: 'registrationDesc', value: 'registrationID' },
      toolbarOptions: ["Search"],
      pageSettings: { pageSize: 10 },
      target: "#target",
      wrapSettings: { wrapMode: "Content" },
    };
  },
  mounted() {
  },
  async created() {
    if (this.$route.params.id !== '0') {
      this.id = this.$route.params.id;
      await this.getJobEvent();
      await this.getJobEventLogs();
    } else {
      this.id = '';
    }
    // eslint-disable-next-line no-return-assign
    await getOperationalPrices().then((res) => (this.operationalPrices = res.data));
  },
  computed: {
    ...mapGetters({
      jobEvent: 'jobEvent',
      jobEventLogs: "jobEventLogs",
    }),
    eventload() {
      return !!this.jobEvent;
    },
    minVal() {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth();
      const currentDay = today.getDate() + 1;
      return new Date(currentYear, currentMonth, currentDay);
    },
    maxVal() {
      const today = new Date();
      const currentYear = today.getFullYear() + 2;
      const currentMonth = today.getMonth();
      const currentDay = today.getDate();
      return new Date(currentYear, currentMonth, currentDay);
    },
  },

  methods: {
    onCancelButtonClick() {
      this.$router.push('/job-events-list');
    },
    async onSubmitButtonClick(e) {
      if (this.id === null || this.id === '') {
        e.Cancel = true;
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'Missing primary key, cannot update!',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
        this.$parent.$refs.notifierRef.show();
        return;
      }
      let formDataFail = false;
      let errorMessage = '';
      if (this.jobEvent.description === null || this.jobEvent.description === '') {
        formDataFail = true;
        errorMessage += 'Please check Description!<br>';
      }
      if (this.jobEvent.jobCategroy !== 'Job' && (this.jobEvent.waitPeriod === 0 || this.jobEvent.waitPeriod === '')) {
        formDataFail = true;
        errorMessage += 'Please check waitPeriod!<br>';
      }
      if (this.jobEvent.jobCategroy === 'Job' && !this.jobEvent.startDate) {
        formDataFail = true;
        errorMessage += 'Start Date is Required!<br>';
      }
      if (this.jobEvent.jobCategroy === 'Job' && !this.jobEvent.tmsRegistrationId) {
        formDataFail = true;
        errorMessage += 'Registration is Required!<br>';
      }
      if (formDataFail) {
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: errorMessage,
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
        this.$parent.$refs.notifierRef.show();
        return;
      }
      try {
        const data = this.jobEvent;
        await this.$store.dispatch(POST_JOB_EVENT, { data });
        this.$parent.notificationToasts.push({
          title: 'Success!',
          content: 'Job / Auto Email saved.',
          cssClass: 'e-toast-success',
          timeOut: 5000,
        });
        this.$router.push('/job-events-list');
      } catch (error) {
        // console.log(`new price error: ${error.message}`);
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'Please verify the form data.',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
    async getJobEvent() {
      try {
        if (this.id != null && this.id !== '') {
          const jobId = this.id;
          await this.$store.dispatch(FETCH_JOB_EVENT, jobId);
        }
      } catch (err) {
        console.error('user accounts err', err);
        if (err.message === 'Network Error') {
          this.$router.push({ name: 'NotFound' });
        } else {
          this.$router.push({ name: 'UnAuthorized' });
        }
      }
    },
    async getJobEventLogs() {
      try {
        if (this.id != null && this.id !== '') {
          const { jobCode } = this.jobEvent;
          await this.$store.dispatch(FETCH_JOB_EVENT_LOGS, { jobCode });
        }
      } catch (err) {
        console.error('user accounts err', err);
        if (err.message === 'Network Error') {
          this.$router.push({ name: 'NotFound' });
        } else {
          this.$router.push({ name: 'UnAuthorized' });
        }
      }
    },
  },
};
</script>

<style>
 @import '../../../assets/styles/eservices-base.css';
 @import "../../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-lists/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-popups/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-richtexteditor/styles/material.css";
 .e-card-content {
  margin: 0% !important;
}
</style>
